import * as React from 'react'
import { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import DanceAddonContent from './_components/DanceAddonContent'
import RegularSportContent from './_components/RegularSportContent'

interface ICancelActiveSport {
    show: boolean
    dictKey: string
    wasActive: boolean
    parent?: string | undefined
    sectionName: string
    setShowPopup: (show: boolean) => void
    cancelActiveSport: (dictKey: string, wasActive: boolean, parent?: string) => void
}

const TURNEN_SPORTS: string[] = [
    'Ballett',
    'Bauchtanz',
    'kreativer Kindertanz',
    'Rückenfit',
    'Stepptanz',
    'Trampolinturnen',
    'Lungensport ohne Verordnung',
    'Osteoporose',
    'Rhythmische Sportgymnastik',
    'Yoga',
    'Eltern-Kind-Turnen (Erw)',
    'Eltern-Kind-Turnen (Kind)',
    'Breakdance',
    'Cheerleading',
    'Hip Hop',
    'Jazz/Modern/Contemporary',
    'Krebsnachsorge ohne Verordnung',
]

const CancelActiveSport = ({
    show,
    dictKey,
    wasActive,
    parent,
    sectionName,
    cancelActiveSport,
    setShowPopup,
}: ICancelActiveSport): JSX.Element => {
    const [showWait, setShowWait] = useState(false)
    const [showError, setShowError] = useState(false)

    const isDanceAddon = TURNEN_SPORTS.includes(sectionName)

    const hideCancelDialog = () => {
        setShowPopup(false)
    }

    const hideErrorDialog = () => {
        setShowError(false)
    }

    const handleCancelActive = async () => {
        setShowWait(true)
        cancelActiveSport(dictKey, wasActive, parent)
    }

    return (
        <>
            <Modal
                show={showWait}
                onHide={() => {
                    /* do nothing */
                }}
            >
                <Modal.Header>
                    <Modal.Title>Sparte/Zusatzangebot austreten</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Bitte warten während wir Ihre Anfrage bearbeiten...</p>
                </Modal.Body>
            </Modal>

            <Modal show={showError} onHide={hideErrorDialog}>
                <Modal.Header closeButton>
                    <Modal.Title>Sparte/Zusatzangebot austreten</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Es ist ein Fehler aufgetreten.</p>
                    <p>Bitte melden Sie sich ab und wieder an.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="rounded-0" variant="primary" onClick={hideErrorDialog}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={hideCancelDialog}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isDanceAddon
                            ? 'Austritt aus Zusatzangebot bestätigen'
                            : 'Austritt aus Sparte/ Abteilung bestätigen'}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {isDanceAddon ? (
                        <DanceAddonContent sectionName={sectionName} />
                    ) : (
                        <RegularSportContent sectionName={sectionName} />
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button className="rounded-0" variant="secondary" onClick={hideCancelDialog} disabled={showWait}>
                        Abbrechen
                    </Button>
                    <Button className="rounded-0" variant="primary" onClick={handleCancelActive} disabled={showWait}>
                        Austritt aus Sparte/ Abteilung
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CancelActiveSport
